/* GMU favourites (T26). No account, no app: product handles in localStorage ('gmu-fav', newest first, max 100; every
   access in try/catch, so private mode / blocked storage just means nothing is kept).
   Hearts = [data-fav="<handle>"] toggle buttons (snippets/gmu-fav-btn.liquid: cards top-right of the photo, PDP next to the
   title); aria-pressed follows the list. Header heart: [data-fav-count] bubble (hidden at 0) + link label with the count.
   Favourites page ([data-fav-page], sections/gmu-favourites.liquid): each saved product rendered as the real
   gmu-product-card via the Section Rendering API (/products/<handle>?section_id=gmu-fav-card, 4 requests at a time),
   in saved order; products that are gone (404 or an empty section) are dropped from the list; un-hearting on the page removes the card.
   Other tabs stay in step through the storage event (a card un-hearted in another tab leaves the page too). If every
   product fetch fails the page shows a retry line, not the empty state. On the page each heart is pinned to its saved
   handle (data-fav-pin), so a colour swap on the card does not move it (gmu-quickadd.js) and un-hearting removes that entry.
   Cards added after load (infinite scroll, filter swap, PDP recs) are synced by their inserting scripts via gmuFav.syncAll();
   pages restored from the back/forward cache re-sync on pageshow. */
(function () {
  if (window.gmuFav) return;
  var KEY = 'gmu-fav', MAX = 100;
  var S = window.gmuStrings || {};

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string' && x; }) : [];
    } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); return true; } catch (e) { return false; }
  }

  var live = null;
  function announce(msg) {
    if (!msg) return;
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden gmu-sr';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }

  function sync(btn, list) {
    list = list || read();
    btn.setAttribute('aria-pressed', list.indexOf(btn.getAttribute('data-fav')) !== -1 ? 'true' : 'false');
  }
  function syncAll() {
    var list = read();
    document.querySelectorAll('[data-fav]').forEach(function (b) { sync(b, list); });
    document.querySelectorAll('[data-fav-link]').forEach(function (a) {
      var c = a.querySelector('[data-fav-count]');
      if (c) { c.textContent = list.length > 99 ? '99+' : String(list.length); c.hidden = !list.length; }
      var l = list.length ? a.getAttribute('data-label-n') : a.getAttribute('data-label');
      if (l) a.setAttribute('aria-label', l.replace('__N__', list.length));
    });
  }
  function toggle(h) {
    var a = read(), i = a.indexOf(h);
    if (i === -1) a.unshift(h); else a.splice(i, 1);
    write(a);
    syncAll();
    announce(i === -1 ? S.favAdded : S.favRemoved);
    return i === -1;
  }

  /* ---- favourites page ---- */
  var pg = null;
  function pageCount() {
    if (!pg) return;
    var grid = pg.querySelector('[data-fav-grid]'), st = pg.querySelector('[data-fav-status]'), empty = pg.querySelector('[data-fav-empty]');
    var err = pg.querySelector('[data-fav-error]');
    var n = grid ? grid.children.length : 0;
    if (st) st.textContent = n ? (n === 1 ? st.getAttribute('data-one') : st.getAttribute('data-other').replace('__N__', n)) : '';
    if (empty) empty.hidden = n > 0 || !!(err && !err.hidden);
    if (grid) grid.hidden = !n;
  }
  function initPage() {
    pg = document.querySelector('[data-fav-page]');
    if (!pg) return;
    var grid = pg.querySelector('[data-fav-grid]'), st = pg.querySelector('[data-fav-status]'), err = pg.querySelector('[data-fav-error]');
    var list = read();
    if (grid) grid.innerHTML = '';
    if (err) err.hidden = true;
    pg.classList.add('is-loading');
    if (!list.length || !grid) { pg.classList.remove('is-loading'); pageCount(); return; }
    if (st) st.textContent = st.getAttribute('data-loading') || '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var res = new Array(list.length), next = 0, active = 0, done = 0;
    function finish() {
      var gone = [], failed = 0;
      res.forEach(function (html, i) {
        if (html === 'gone') { gone.push(list[i]); return; }
        if (!html || html === 'err') { failed++; return; }
        var t = document.createElement('template');
        t.innerHTML = html;
        var card = t.content.querySelector('[data-gmu-card]');
        /* a missing / unpublished product answers 200 with an empty section: drop it like a 404 */
        if (!card) { gone.push(list[i]); return; }
        /* the saved handle, so un-hearting removes this entry even if the shop answered with a renamed / translated handle */
        var hb = card.querySelector('[data-fav]');
        if (hb) { hb.setAttribute('data-fav', list[i]); hb.setAttribute('data-fav-pin', ''); }
        var li = document.createElement('li');
        li.setAttribute('data-fav-saved', list[i]);
        li.appendChild(card);
        grid.appendChild(li);
      });
      if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
      /* all (or some) products could not be loaded (offline, server error): offer a retry, never "No favourites yet" */
      if (err) err.hidden = !failed;
      pg.classList.remove('is-loading');
      syncAll();
      pageCount();
    }
    function pump() {
      while (active < 4 && next < list.length) {
        (function (i) {
          active++;
          fetch(root + 'products/' + encodeURIComponent(list[i]) + '?section_id=gmu-fav-card', { credentials: 'same-origin' })
            .then(function (r) {
              if (r.status === 404) return 'gone';
              if (!r.ok) throw new Error(r.status);
              return r.text();
            })
            .then(function (html) { res[i] = html; }, function () { res[i] = 'err'; })
            .then(function () {
              active--; done++;
              if (done === list.length) finish(); else pump();
            });
        })(next++);
      }
    }
    pump();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault();
    var on = toggle(b.getAttribute('data-fav'));
    if (!on && pg && pg.contains(b)) {
      /* un-hearted on the favourites page: drop the card, keep focus in the list */
      var li = b.closest('li'), nx = li && (li.nextElementSibling || li.previousElementSibling);
      if (li) li.remove();
      pageCount();
      var f = nx && nx.querySelector('[data-fav]');
      if (f) f.focus();
      else { var h = pg.querySelector('h1'); if (h) h.focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-fav-retry]')) initPage();
  });
  /* another tab changed the list: sync hearts; on the favourites page drop cards that are no longer saved */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY && e.key !== null) return;
    syncAll();
    if (!pg) return;
    var list = read(), grid = pg.querySelector('[data-fav-grid]');
    if (!grid) return;
    grid.querySelectorAll('li[data-fav-saved]').forEach(function (li) {
      if (list.indexOf(li.getAttribute('data-fav-saved')) === -1) li.remove();
    });
    pageCount();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncAll(); });

  window.gmuFav = { read: read, toggle: toggle, sync: function (b) { sync(b); }, syncAll: syncAll };
  syncAll();
  initPage();
})();
